import { get, patch } from 'store/http/httpAction';
import _ from 'lodash';
import { GLOBAL_SEARCH_SET_RESULTS, GLOBAL_SEARCH_SET_SEARCHKEY, GLOABL_SEARCH_SET_PAGENATION, GLOBAL_SEARCH_SET_RESULTS_COLUMN_META, GLOBAL_SEARCH_SET_SEARCHMETHOD } from './actionType';
import { setAvailableFields, setIsDefaultField, addToSelection } from 'components/page/ObjectFilter/components/FieldsSelection/flow/actions';
import { OBJECT_TYPES } from 'config/app.config';
import Enums from 'utils/EnumsManager';

const { SearchMethodKeys } = Enums;
const { Phrase } = SearchMethodKeys;

const { leads, accounts, opportunities } = OBJECT_TYPES;

export const setSearchResult = (objType, result) => ({
  type: GLOBAL_SEARCH_SET_RESULTS,
  objType,
  result,
});

export const setSearchKey = keys => ({
  type: GLOBAL_SEARCH_SET_SEARCHKEY,
  keys,
});

export const setSearchMethod = keys => ({
  type: GLOBAL_SEARCH_SET_SEARCHMETHOD,
  keys,
});

export const setPagenation = (objType, perPage, currentPage, total) => ({
  type: GLOABL_SEARCH_SET_PAGENATION,
  objType,
  perPage,
  currentPage,
  total,
});

export const setColumnMeta = (objType, meta) => ({
  type: GLOBAL_SEARCH_SET_RESULTS_COLUMN_META,
  objType,
  meta,
});

const setData = (objType, data, dispatch) => {
  if (!_.isEmpty(data)) {
    dispatch(setSearchResult(objType, data.index.data));
    const { total, per_page, current_page } = data.index.meta.pagination;
    dispatch(setPagenation(objType, per_page, current_page, total));
    dispatch(setColumnMeta(objType, data.selector_meta.data));
  }
};

export const fetchResultFromRemote = (search, method) => dispatch => get('/admin/objects/search', { search, exact_match: method }, dispatch).then((data) => {
  if (!_.isEmpty(data)) {
    setData(leads, data[leads], dispatch);
    setData(accounts, data[accounts], dispatch);
    setData(opportunities, data[opportunities], dispatch);
  }
});

export const fetchResultByObjtype = (objType, search, per_page, page) => dispatch => get(`/admin/objects/search/object_type/${objType}`, { search, per_page, page }, dispatch).then((data) => {
  setData(objType, data, dispatch);
});

export const fetchObjectAllFields = objectType => (dispatch, getState) =>
  get(`/admin/metadata/object/${objectType}`, {}, dispatch).then((data) => {
    const store = getState();
    const { selectedFields } = store.objectView.fields;
    if (data) {
      const main =
        data.main && _.isArray(data.main.data) ? data.main.data : [];
      const cstm =
        data.cstm && _.isArray(data.cstm.data) ? data.cstm.data : [];
      const columns = [...main, ...cstm];
      dispatch(setAvailableFields(columns, true));
      // reset the selectedFields is due to the function of filter of setAvailableFields need to be uesed
      if (_.isArray(selectedFields)) {
        dispatch(addToSelection(selectedFields));
      }
    }
  });

export const updateModuleColumnsByType = (object_type, moduleFields, cb) => (dispatch, getStore) =>
  patch(`/admin/metadata/search_layout/object/${object_type}/fields/me`, { field_ids: moduleFields }, dispatch).then(data => {
    const store = getStore();
    const { globalSearchKey, globalSearchMethod } = store.globalSearch;
    if (data) {
      dispatch(setIsDefaultField(data.use_default));
      if (_.isFunction(cb)) {
        cb();
      }
      const method = globalSearchMethod === Phrase ? '1' : '0';
      dispatch(fetchResultFromRemote(globalSearchKey, method));
    }
  });

export const fetchObjectSelectedField = objectType => dispatch =>
  get(`/admin/metadata/search_layout/object/${objectType}/fields/me/final`, {}, dispatch).then((data) => {
    if (data) {
      if (data.data) {
        dispatch(setColumnMeta(objectType, data.fields.data));
      }
      dispatch(setIsDefaultField(data.use_default));
    }
  });



// WEBPACK FOOTER //
// ./src/views/GlobalSearch/flow/action.js